<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
        :isEdit="isEdit"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_OIL_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountGlobalSharedContext.oil;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(oil) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_OIL_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(oil, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateOil.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_OIL_QUERY = gql `
  query ($id: ID!) { 
    accountGlobalSharedContext {
      oil (id: $id) {
        id
        description
        barcode
        taxationGroupId
        groupId
        group {
          id
          name
        }
        brandId
        brand {
          id
          name
        }
        unitId
        unit {
          id
          name
        }
        packagingIds
        validations
      }
    }
    globalContext {
      allUnits {
        id
        name
      }
    } 
    accountGlobalSharedContext {
      allGroupsForOils {
        id
        name
      }
      allBrandsOfItems {
        id
        name
      }
    }
  }
`;

const UPDATE_OIL_MUTATION = gql `
  mutation($input: OilUpdateInputObject!) {
    updateOil(input: $input) {
      item {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>